import React, { useEffect, useRef } from 'react'
import logo from '../../../assets/newLogo01.png'
import { useLocation } from 'react-router-dom';

export const AboutHeader = () => {
    const hero = useRef('');
    const { pathname } = useLocation();
    useEffect(() => {
        if (hero.current && (pathname === '/about')) {
            hero.current.scrollIntoView({ behavior: 'instant' });
        }
    }, [pathname]);
    return (
        <>
            {/* // This is the about header */}
            <div ref={hero} className="flex flex-wrap justify-between w-full p-[10vw] flex-auto items-center">

                {/* // This is the image */}
                <img src={logo} alt="Clinic Preview " className=' w-[45%] max-lg:w-[90%] ' />

                {/* // This is the description */}
                <div className='w-[45%] max-lg:w-[90%] flex flex-col gap-5'>
                    <p>
                        Imagine a company that doesn't shy away from complexity. We are trailblazers,  conquering the most intricate challenges in software development. We don't just build products; we craft the very foundations upon which the next generation of software is built.
                    </p>
                    <p>
                        By tackling complex problems and building foundational platforms, we pave the way for a more robust and innovative software landscape. Our developer-centric approach fosters a thriving ecosystem, accelerating the creation of groundbreaking applications that touch every aspect of our lives.
                    </p>
                    <p>
                        If you are a passionate problem-solver, a visionary architect, or a developer yearning to push the envelope, then we invite you to join us. Together, let's shape the future of software.
                    </p>

                    <p className='text-blue-500 font-semibold'>
                        Think better , Leap Ahead
                    </p>

                </div>


            </div>
        </>
    )
}
